// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const Masters = [
  {
    title: 'User',
    path: '/dashboard/masters/user',
    icon: icon('user'),
    ShortName: 'User_Master',
  },
  {
    title: 'Defect Category',
    path: '/dashboard/masters/DefectCategory',
    icon: icon('user'),
    ShortName: 'DefectCategory_Master',
  },
  {
    title: 'Defect Sub Category',
    path: '/dashboard/masters/DefectSubCategory',
    icon: icon('user'),
    ShortName: 'DefectSubCategory_Master',
  },
  {
    title: 'Audit Type',
    path: '/dashboard/masters/AuditType',
    icon: icon('user'),
    ShortName: 'AuditType_Master',
  },
  {
    title: 'Audit Mapping',
    path: '/dashboard/masters/AuditMapping',
    icon: icon('user'),
    ShortName: 'AuditMapping_Master',
  },
  {
    title: 'Factory Process Unit',
    path: '/dashboard/masters/FactoryProcessUnit',
    icon: icon('user'),
    ShortName: 'FactoryProcessUnit_Master',
  },
  {
    title: 'AQL Parameter',
    path: '/dashboard/masters/AQLParameter',
    icon: icon('user'),
    ShortName: 'AQLParameter_Master',
  },
  {
    title: 'Fabric Roll Parameter',
    path: '/dashboard/masters/FabricRollParameter',
    icon: icon('user'),
    ShortName: 'FabricRollParameter_Master',
  },
  {
    title: 'Fabric Defect',
    path: '/dashboard/masters/FabricDefect',
    icon: icon('user'),
    ShortName: 'FabricDefect_Master',
  },
  {
    title: 'Fabric Defect Points',
    path: '/dashboard/masters/FabricDefectPoints',
    icon: icon('user'),
    ShortName: 'FabricDefectPoints_Master',
  },
  {
    title: 'Factory Location',
    path: '/dashboard/masters/factorylocation',
    icon: icon('user'),
    ShortName: 'FactoryLocation_Master',
  },
  {
    title: 'User Privileges',
    path: '/dashboard/masters/UserPrivileges',
    icon: icon('user'),
    ShortName: 'UserPrivileges_Master',
  },
];

export default Masters;
